<template>
  <div>
    <div v-if="noOrders" class="jumbotron">
      <div class="container">
        <h1 class="display-4">Empty Order Cart</h1>
        <p class="lead">
          This is a modified jumbotron that occupies the entire horizontal space
          of its parent.
        </p>
      </div>
    </div>
    <div
      v-else
      v-for="(order, index) in orders"
      :key="index"
      class="card col-12 col-sm-4 col-md-4 col-lg-3"
      style="width: 18rem"
    >
      <div id="topbody" class="card-body total">
        <h5 class="card-title">{{ order.user.name }}</h5>
        <p class="card-text">
          {{ order.user.email }}
        </p>
        <p class="card-text">
          {{ order.user.address }}
        </p>
      </div>
      <ul class="list-group list-group-flush">
        <li
          v-for="(item, index) in order.items"
          :key="index"
          class="list-group-item"
        >
          <span class="order-model">{{ item.title }}-{{ item.model }}</span>
          <span class="order-price">price-{{ item.price }}$</span>
        </li>
        <li class="text-center list-group-item total">
          Total-{{ order.total }}$
        </li>
      </ul>
      <div class="card-footer text-center">
        <div v-if="loginInfo.name == 'admin'">
          <button type="button" class="btn btn-outline-success">Accept</button>
          <button type="button" class="btn btn-outline-danger">Deny</button>
        </div>
        <div v-else>
          <button id="cancle" type="button" class="btn btn-outline-danger">
            Cancle
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["orders", "noOrders"],
  computed: {
    loginInfo() {
      return this.$store.getters.getStatus;
    },
    // total() {
    //   var total = 0;
    //   this.orders.forEach((order) => {
    //     order.items.forEach((item) => {
    //       total += parseFloat(item.price);
    //     });
    //   });
    //   return total.toFixed(2);
    // },
  },
};
// setTimeout(function() {
//   var max = 13;
//   var tot, str;
//   $(".order-model").each(function() {
//     str = String($(this).html());
//     tot = str.length;
//     str = tot <= max ? str : str.substring(0, max + 1) + "...";
//     $(this).html(str);
//   });
// }, 500);
</script>
<style scoped>
ul {
  margin: 0px !important;
}
#topbody {
  margin-bottom: 0.5rem !important;
}
.btn-outline-danger {
  margin-left: 0.5rem;
}
.order-price {
  color: #28a745;
  background: #343a40;
  float: right;
  font-weight: 600;
  font-style: italic;
  padding: 0.75rem 1.25rem;
}
.total {
  background: #343a40;
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.list-group-item {
  padding: 0rem !important;
}
.order-model {
  font-size: 12px;
  font-weight: 600;
  font-style: italic;
  float: left;
  padding: 11px 7px 0px 3px;
}
.card-text {
  margin-bottom: 8px !important;
  font-size: 12px;
}
/* #cancle {
  float: left;
} */
</style>
